import { AxiosResponse } from 'axios'
import { call, put, select } from 'redux-saga/effects'
import {
  logInError,
  logInSuccess,
  CredentialsLogInRequest,
  ProviderLogInRequest,
  logInRequest,
  HeaderEnrichmentLogInRequest,
} from './authActions'
import {
  getTokenByPasswordApi,
  getTokenByAuthProviderApi,
  GetTokenResponse,
  getTokenByTid,
  getTokenByActionToken,
} from './authApi'
import { i18n } from '../../i18n'
import BugSnag from '../../config/bugsnag'
import { logException, logEvent } from '../../utils/googleAnalytics'
import { watchEidSelector } from '../watch/watchSelectors'

export function* credentialsLogInRequestSaga({ credentials }: CredentialsLogInRequest) {
  yield put(logInRequest())

  try {
    const { data }: AxiosResponse<GetTokenResponse> = yield call(
      getTokenByPasswordApi,
      credentials.username,
      credentials.password
    )
    yield put(logInSuccess({ accessToken: data.access_token }))
    const eId = yield select(watchEidSelector)
    logEvent('Login Success (credentials)', `WatchEid: ${eId}`)
  } catch (err) {
    const errorMessage = i18n.t('common:credentialsLoginError')
    BugSnag.bugsnagClient.notify(err)
    logException(errorMessage)
    yield put(
      logInError({
        error: errorMessage,
      })
    )
  }
}

export function* providerLogInRequestSaga({ code }: ProviderLogInRequest) {
  yield put(logInRequest())

  try {
    const { data }: AxiosResponse<GetTokenResponse> = yield call(getTokenByAuthProviderApi, code)
    yield put(logInSuccess({ accessToken: data.access_token }))
    const eId = yield select(watchEidSelector)
    logEvent('Login Success (provider)', `WatchEid: ${eId}`)
  } catch (err) {
    const errorMessage = i18n.t('common:providerLoginError')
    BugSnag.bugsnagClient.notify(err)
    logException(errorMessage)
    yield put(
      logInError({
        error: errorMessage,
      })
    )
  }
}

export function* headerEnrichmentLogInRequestSaga({ tid, errorCallback }: HeaderEnrichmentLogInRequest) {
  yield put(logInRequest())

  try {
    const {
      data: { action_token: action_token },
    }: AxiosResponse<{ action_token: string }> = yield call(getTokenByTid, tid)
    if (!action_token) {
      throw new Error('No action token returned')
    }
    const { data }: AxiosResponse<GetTokenResponse> = yield call(getTokenByActionToken, action_token)
    yield put(logInSuccess({ accessToken: data.access_token }))
    const eId = yield select(watchEidSelector)
    logEvent('Login Success (provider)', `WatchEid: ${eId}`)
  } catch (err) {
    const errorMessage = 'Header enrichment saga error'
    BugSnag.bugsnagClient.notify(err)
    logException(errorMessage)
    yield call(errorCallback)
    yield put(
      logInError({
        error: errorMessage,
      })
    )
  }
}
